const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "table.zones/SET_TABLE_PARAMS":
            return {
                ...state,
                ...action.params
            };
        case "table.zones/LIST_ZONES_SUCCESS":
            return {
                ...state,
                data: action.response.data,
                filters: action.response.filters,
                ...action.response.pagination
            };
        default:
            return state;
    }
}
